import { render } from "./agregarSiniestro.vue?vue&type=template&id=68f6b42e&scoped=true"
import script from "./agregarSiniestro.vue?vue&type=script&lang=js"
export * from "./agregarSiniestro.vue?vue&type=script&lang=js"

import "./agregarSiniestro.vue?vue&type=style&index=0&id=68f6b42e&lang=css"
import "./agregarSiniestro.vue?vue&type=style&index=1&id=68f6b42e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f6b42e"]])

export default __exports__